<template>
  <div :class="classList" :id="id">
    <div class="d-flex justify-content-between">
      <h3 class="d-flex">
        {{ sectionTitle }}
      </h3>
    </div>
    <hr style="margin: 0" />

    <div class="one-line-description" v-if="user && user.id">
      <span>
        {{ getLabelByKeys("BOOKING_SECTION.DESCRIPTION.CLICK_ON_BOOKING") }}
      </span>
    </div>
    <div class="description" v-if="description && description !== ''">
      <div v-html="description"></div>
    </div>
    <CheckboxItem
      v-if="user && user.id"
      label="Toggle Table View"
      name="table-view-shift-job"
      v-model="isTableView"
    />
    <div class="row booking-calendar-container">
      <div v-if="!isTableView" class="col-lg-8 mb-5 mt-3">
        <div class="mb-2 calendar-btns">
          <button
            class="mylisting-button"
            :class="{ 'dark-button': tab == 'week' }"
            @click="tab = 'week'"
          >
            Week View
          </button>
          <button
            class="mylisting-button"
            :class="{ 'dark-button': tab == 'month' }"
            @click="tab = 'month'"
          >
            Month View
          </button>
        </div>
        <div class="calendar calendar-parent-container">
          <calendar-view
            v-if="tab == 'month'"
            :show-date="showDate"
            class="theme-default holiday-us-traditional holiday-us-official"
            @click-date="onClickDate"
            @click-event="onClickItem"
            event-content-height="2.4em"
            :events="listShowCalendarJobs"
            style="min-height: 550px"
          >
            <div slot="dayContent" slot-scope="{ day }">
              <div style="padding: 0.2em 0">{{ getNumberOfJob(day) }}</div>
            </div>
            <calendar-view-header
              slot="header"
              slot-scope="t"
              :header-props="t.headerProps"
              @input="setShowDate"
            />
          </calendar-view>

          <calendar-view
            v-if="tab == 'week'"
            :show-date="showDate"
            class="theme-default holiday-us-traditional holiday-us-official"
            @click-date="onClickDate"
            @click-event="onClickItem"
            display-period-uom="week"
            event-content-height="5em"
            style="min-height: 550px"
            :events="listShowCalendarJobs"
          >
            <div slot="dayContent" slot-scope="{ day }">
              <div style="padding: 0.2em 0">{{ getNumberOfJob(day) }}</div>
            </div>
            <calendar-view-header
              slot="header"
              slot-scope="t"
              :header-props="t.headerProps"
              @input="setShowDate"
            />
          </calendar-view>
        </div>
      </div>
      <div :class="isTableView ? 'col-lg-12' : 'col-lg-4'">
        <h4 class="pt-3">
          {{ getLabelByKeys("BOOKING_SECTION.LABEL.BOOKINGS") }}
        </h4>
        <div
          class="hide-past-booking"
          v-if="bookingData && bookingData.length > 0"
        >
          <input
            class="form-check-input"
            type="checkbox"
            :value="true"
            id="past-booking"
            v-model="hidePastBooking"
          />
          <label class="form-check-label" for="past-booking">
            {{ getLabelByKeys("BOOKING_SECTION.LABEL.HIDE_PAST_BOOKINGS") }}
          </label>
          <div v-if="!hidePastBooking" class="past-booking-filter mt-1">
            <label> Number of days in the past to load past booking</label>
            <input
              type="Number"
              class="form-control"
              v-model="numberOfPastDays"
            />
          </div>
        </div>
        <hr />
        <div class="booking-detail-container" v-if="isTableView">
          <p
            class="required-message"
            v-if="minCount && bookingData.length < minCount && submitClicked"
          >
            {{
              getLabelByKeys(
                minCount == 1? "BOOKING_SECTION.LABEL.MIN_BOOKING_REQUIRE" : "BOOKING_SECTION.LABEL.MIN_BOOKINGS_REQUIRE",
                minCount
              )
            }}
          </p>
          <div
            class="row label-no-margin-top mb-2 field-of-fields"
            v-if="listShowBooking && listShowBooking.length"
          >
            <div class="col">
              <datepicker
                v-model="filterStart"
                :placeholder="
                  getLabelByKeys('PLACE_HOLDERS.FILTER_BY_START_DATE')
                "
                :clear-button="true"
                :bootstrap-styling="true"
              ></datepicker>
            </div>
            <div class="col">
              <datepicker
                v-model="filterEnd"
                :placeholder="
                  getLabelByKeys('PLACE_HOLDERS.FILTER_BY_END_DATE')
                "
                :clear-button="true"
                :bootstrap-styling="true"
              ></datepicker>
            </div>
          </div>
          <DataTable
            :listHeaders="listTableFieldsBooking"
            :listData="listShowBookingTableView"
            :isCandidateTable="false"
            :showCheckbox="false"
            :sortInfo="{ model: 'date', order: 1 }"
          >
            <template #header>
              <th>{{ getLabelByKeys("TABLE_HEADERS.ACTIONS") }}</th>
            </template>
            <template #actions="{ data }">
              <td class="align-center">
                <span
                  v-if="
                    (data.status !== JOB_STATUSES.CANCELLED &&
                      !isPastBooking(data) &&
                      canEditBooking(data.status)) ||
                    isAgent
                  "
                  class="icon-button-table"
                  @click="handleClickEditBooking(data)"
                  v-tooltip="'Edit'"
                >
                  <i class="material-icons"> edit </i>
                </span>
                <span
                  class="icon-button-table"
                  v-if="editAccess"
                  @click="handleClickDuplicateBooking(data)"
                  v-tooltip="'Duplicate'"
                >
                  <i class="material-icons"> control_point_duplicate </i>
                </span>

                <ReportProblemButtons :job="data" :user="user" />
              </td>
            </template>
          </DataTable>
        </div>
        <div v-else class="booking-detail-container">
          <p v-if="!bookingData.length">
            {{ getLabelByKeys("BOOKING_SECTION.DESCRIPTION.CLICK_ON_DATE") }}
          </p>
          <p
            class="required-message"
            v-if="minCount && bookingData.length < minCount && submitClicked"
          >
            {{
              getLabelByKeys(
                minCount == 1? "BOOKING_SECTION.LABEL.MIN_BOOKING_REQUIRE" : "BOOKING_SECTION.LABEL.MIN_BOOKINGS_REQUIRE",
                minCount
              )
            }}
          </p>
          <div
            v-for="(job, index) in listShowBookingCurrentPage"
            :key="'job' + index"
            class="booking-container"
          >
            <div class="icon-containers">
              <span
                class="expand-button"
                v-if="job.isExpand"
                @click="job.isExpand = false"
              >
                <i class="material-icons"> arrow_drop_down </i>
              </span>
              <span class="expand-button" v-else @click="expandBooking(job)">
                <i class="material-icons"> arrow_right </i>
              </span>
            </div>
            <div
              style="background-color: var(--bootstrapgrey)"
              class="px-3 py-2 mx-1 my-1 booking-detail"
            >
              <p style="margin-bottom: 0" v-if="job.date">
                {{ getTitle(job) }}
                <!-- {{ new Date(addCurrentTimeToDate(job.date)).toDateString() }} -->
              </p>
              <div v-show="job.isExpand">
                <p
                  style="margin-bottom: 0"
                  v-if="job.start_time && job.end_time"
                >
                  {{ convertTimeStringToStringAMPM(job.start_time) }} -
                  {{ convertTimeStringToStringAMPM(job.end_time) }}
                </p>
                <p class="field-of-fields" v-if="job.status">
                  <label>Status:</label> {{ job.status }}
                </p>

                <DetailSectionRowLayout
                  :modelData="job"
                  :user="user"
                  labelKey="labelDetail"
                  :listFields="listDisplayBookingFields"
                  :listExcludeFields="['start_time', 'end_time', 'end_date']"
                />
                <div v-if="job.filler">
                  <label>
                    {{
                      getLabelByKeys(
                        "BOOKING_SECTION.LABEL.SELECTED_CANDIDATE"
                      )
                    }}:
                  </label>
                  {{ getBookingFillerName(job) }}
                </div>
                <BookingPriceInfo
                  class="mt-2 price-info-container"
                  :job="job"
                  :originalJob="job"
                  :listPrices="priceList"
                  :user="user"
                  :categoryList="categoryList"
                  :numberOfAllowedChildren="numberOfAllowedChildren"
                  :numberOfBooking="
                    api ? 1 : getListDateOfRepeatBooking(job).length
                  "
                  :listDateTimesOfJobs="getListDateTimeOfJobs(job)"
                  :viewOnly="true"
                  ref="priceInfo"
                />
                <p class="booking-buttons-container" v-if="!isViewOnly">
                  <span
                    v-if="
                      (job.status !== JOB_STATUSES.CANCELLED &&
                        !isPastBooking(job) &&
                        canEditBooking(job.status)) ||
                      isAgent
                    "
                    class="booking-button"
                    @click="handleClickEditBooking(job, index)"
                  >
                    {{ getLabelByKeys("BUTTONS.EDIT") }}
                  </span>
                  <span
                    v-if="
                      (job.status !== JOB_STATUSES.CANCELLED &&
                        !isPastBooking(job) &&
                        canEditBooking(job.status) &&
                        editAccess) ||
                      isAgent
                    "
                  >
                    |
                  </span>
                  <span
                    class="booking-button"
                    v-if="editAccess"
                    @click="handleClickDuplicateBooking(job)"
                  >
                    {{ getLabelByKeys("BUTTONS.DUPLICATE") }}
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div class="text-center mt-2" v-if="totalPage > 1">
            <ul class="pagination justify-content-center">
              <li
                class="page-item"
                v-if="currentPage > 1"
                @click="currentPage = currentPage - 1"
              >
                <a class="page-link nav-button">
                  <i class="material-icons">skip_previous</i>Previous
                </a>
              </li>
              <li
                class="page-item"
                v-if="currentPage < totalPage"
                @click="currentPage = currentPage + 1"
              >
                <a class="page-link nav-button">
                  Next<i class="material-icons">skip_next</i>
                </a>
              </li>
            </ul>
          </div>
          <div v-if="calculateTotalBookingFee() && !auth">
            <label class="mt-2" style="">
              {{ getLabelByKeys("BOOKING_SECTION.LABEL.TOTAL_BOOKING_FEE") }}:
            </label>
            ${{ calculateTotalBookingFee() | twoDecimals }}
          </div>
          <small v-if="bookingData.length" class="mt-3">
            <div class="d-inline" v-html="disclaimerText"></div>
          </small>
        </div>
        <p
          v-if="!isTableView && bookingData.length && !isViewOnly"
          class="mt-3 mb-3"
        >
          {{
            getLabelByKeys("BOOKING_SECTION.DESCRIPTION.CLICK_ON_OTHER_DATE")
          }}
        </p>
        <button
          v-if="!isViewOnly"
          class="mylisting-button dark-button add-booking"
          @click="clickAddBooking()"
        >
          {{ getLabelByKeys("BUTTONS.ADD_A_BOOKING") }}
        </button>
        <hr />
        <!-- Job Groups -->
        <div v-if="acceptJobsByGroup">
          <h4>{{ getLabelByKeys("BOOKING_SECTION.LABEL.BOOKING_GROUPS") }}</h4>
          <small>
            {{ getLabelByKeys("BOOKING_SECTION.DESCRIPTION.BOOKING_GROUP") }}
          </small>
          <div>
            <div
              v-for="(jobs, group_id) in mapBookingGroup"
              :key="'group' + group_id"
            >
              <div class="booking-group">
                <div class="booking-group-info">
                  <div
                    class="mt-2"
                    v-for="job of jobs"
                    :key="'job-in-group-' + group_id + '-' + job.id"
                  >
                    <div>{{ getTitle(job) }}</div>
                    <small>
                      {{ convertTimeStringToStringAMPM(job.start_time) }} -
                      {{ convertTimeStringToStringAMPM(job.end_time) }}
                    </small>
                  </div>
                </div>
                <span
                  class="delete-group delete-icon"
                  v-if="!isViewOnly"
                  @click="showDeleteGroupConfirm(group_id)"
                >
                  <i class="material-icons"> delete </i>
                </span>
              </div>
              <hr />
            </div>
          </div>
          <button
            v-if="!isViewOnly"
            class="mylisting-button dark-button add-booking"
            @click="showAddGroupDialog()"
          >
            {{ getLabelByKeys("BUTTONS.ADD_A_GROUP") }}
          </button>
          <hr />
        </div>
      </div>
    </div>
    <UpdateBookingDialog
      ref="updateBookingDialog"
      name="Booking"
      header="Booking"
      :listFields="listUpSertBookingFields"
      :title="dialogTitle"
      :keyTitles="keyTitles"
      v-model="isShowBookingDialog"
      :passedData="booking"
      :selectedDate="dateInDjangoFormat(selectedDate)"
      :isAdd="isAddBookingDialog"
      :showCancel="!!api"
      :user="user"
      :passedCreditCount="creditCount"
      :bookingRequirePaymentInfo="bookingRequirePaymentInfo"
      :listPrices="priceList"
      :listPriceServices="listPriceServices"
      :categoryList="categoryList"
      :candidateList="candidateList"
      :numberOfAllowedChildren="numberOfAllowedChildren"
      :chargeClientWhenBooking="chargeClientWhenBooking"
      :chargeClientWhenAssign="chargeClientWhenAssign"
      :includeCandidatePayment="includeCandidatePayment"
      :employerTypesNotCharge="employerTypesNotCharge"
      :listBookings="bookingData"
      :cancellationPolicy="cancellationPolicy"
      :passedBookingField="bookingField"
      :isInApplicationForm="isInApplicationForm"
      :profileBuilderID="profileBuilderID"
      :isFixedPoster="true"
      @saved="handleUpdateObjects($event)"
      @reloadUser="$emit('reloadUser')"
    />
  </div>
</template>

<script>
import axios from "axios";
import UpdateBookingDialog from "./UpdateBookingDialog";
import ReportProblemButtons from "./ReportProblemButtons";
import {
  ACTION_TYPE,
  FORM_TYPE,
  JOB_STATUSES,
  JOB_UPDATE_STATUS_SENT,
  PRICE_TYPES,
} from "../../../constants/custom-define-type";
import {
  DEFAULT_SHIFT_JOB_STATUSES,
  DEFAULT_DISCLAIMER_TEXT,
} from "../../../constants/default-values";
import { CalendarView, CalendarViewHeader } from "vue-simple-calendar";
require("vue-simple-calendar/static/css/default.css");
import BookingPriceInfo from "./BookingPriceInfo";
import PRICE_INFO_CALCULATION_MIXIN from "./PriceInfoCalculation";
import { mapActions, mapGetters } from "vuex";
import CheckboxItem from "../../common/form-elements/CheckboxItem.vue";
import DataTable from "../../common/DataTable.vue";
import Datepicker from "vuejs-datepicker";
import {
  CLIENT_BOOKING_SETTINGS,
  DISCLAIMER_TEXT_ADDING_BOOKING_SETTING,
} from "../../../constants/agency-settings/job-settings";

/**
 * The component is used to show for the booking section
 */
export default {
  name: "BookingSectionWithDialog",
  props: {
    id: String,
    user: Object,
    sectionTitle: String,
    // Description which are only visible to admin
    adminDescription: String,
    description: String,
    name: String,
    listFields: Array,
    keyTitles: {
      type: Array,
      default: () => ["name"],
    },
    value: {
      type: Array,
      default: () => [],
    },
    submitClicked: {
      type: Boolean,
      default: false,
    },
    classList: {
      type: String,
      default: "",
    },
    categoryList: {
      type: String,
      default: "",
    },
    // If number of children is more than that, additional fee will be added
    numberOfAllowedChildren: {
      type: Number,
      default: 1,
    },
    // Minimum number of item
    minCount: Number,
    api: String,
    excludeChildrenQuestion: {
      type: Boolean,
      default: false,
    },
    excludeAddressQuestion: {
      type: Boolean,
      default: false,
    },
    excludeRepeatBooking: {
      type: Boolean,
      default: false,
    },
    hasNumberCandidateQuestion: {
      type: Boolean,
      default: false,
    },
    hideAdditionalDateQuestion: {
      type: Boolean,
      default: false,
    },
    bookingRequirePaymentInfo: {
      type: Boolean,
      default: false,
    },
    selectAllDaysForRecurringRequests: {
      type: Boolean,
      default: false,
    },
    bookingField: {
      type: Object,
      default: () => {},
    },
    chargeClientWhenBooking: {
      type: Boolean,
      default: false,
    },
    chargeClientWhenAssign: {
      // Setting in profile type builder
      type: Boolean,
      default: false,
    },
    includeCandidatePayment: {
      type: Boolean,
      default: false,
    },
    isInApplicationForm: {
      type: Boolean,
      default: false,
    },
    employerTypesNotCharge: {
      type: Array,
    },
    multipleBookingSections: {
      type: Boolean,
      default: false,
    },
    shiftJobProblemReports: {
      type: Boolean,
      default: false,
    },
    profileBuilderID: Number,
  },
  mixins: [PRICE_INFO_CALCULATION_MIXIN],
  components: {
    UpdateBookingDialog,
    CalendarView,
    CalendarViewHeader,
    BookingPriceInfo,
    CheckboxItem,
    DataTable,
    Datepicker,
    ReportProblemButtons,
  },
  data() {
    return {
      isShowBookingDialog: false,
      booking: {},
      isAddBookingDialog: false,
      indexOfEdittingBooking: 0,
      showDate: new Date(),
      calendarJobs: [],
      dialogTitle: "",
      selectedDate: null,
      batchID: null,
      originalJob: {}, // Job before edit,
      hidePastBooking: true,
      bookingData: [],
      JOB_STATUSES: JOB_STATUSES,
      expandingID: -1,
      tempID: 0, // id of booking before adding to DB
      isShowAssignee: false,
      selectedJob: {},
      listJobFiller: [],
      FORM_TYPE: FORM_TYPE,
      creditCount: 0,
      hasDateQuestion: false,
      DEFAULT_DISCLAIMER_TEXT,
      candidateList: [],
      isTableView: false,
      filterStart: null,
      filterEnd: null,
      tab: "month",
      CLIENT_BOOKING_SETTINGS,
      DISCLAIMER_TEXT_ADDING_BOOKING_SETTING,
      numberOfPastDays: 30,
      smsFooter: "",
      isShowSectionBuilderUpSertDialog: false,
      currentPage: 1,
    };
  },
  async created() {
    // Load prices
    await this.loadPriceList();
    if (
      !this.api &&
      (this.clientCanAssignShiftJobApplicationForm || this.autoAssignCandidate)
    ) {
      const res = await axios.get(
        "get-public-candidates-list/?agency=" + this.agencyID
      );
      this.candidateList = res.data.users;
      this.setPublicCandidateList(this.candidateList);
    }
    if (this.user && this.user.id) {
      await this.loadPreviousMatchCandidatesByEmployer(this.user.id);
    }

    const smsFooterObj = await this.getAdminSetting();
    if (smsFooterObj && smsFooterObj.smsFooter) {
      this.smsFooter = "\n\n" + smsFooterObj.smsFooter;
    }
  },
  computed: {
    ...mapGetters([
      "jobStatusAfterClientSelectCandidate",
      "JobStatusClientCantEditShiftBookings",
      "isAgent",
      "priceList",
      "hourlyServiceSelectionList",
      "quickbooksPriceSelectionList",
      "candidateListMainInfo",
      "tentativeAssignStatus",
      "jobTypeShortTermQuery",
      "agency",
      "sendNotificationToFillerOnChange",
      "notifyAllApplicants",
      "clientCanSelectMultipleCandidates",
      "showWeeklyScheduleReleaseButton",
      "preReleaseShiftJobStatus",
      "disclaimerTextBookingSection",
      "showIdClientSideShiftJobCalendar",
      "clientCanAssignShiftJob",
      "clientCanAssignShiftJobApplicationForm",
      "agencyID",
      "employerShiftRequestEmails",
      "acceptJobsByGroup",
      "multipleFillersShiftJob",
      "hideCandidateLastNameForShiftJobs",
      "autoAssignCandidate",
      "agencyCurrency",
      "clientTypesViewOnlyBooking",
      "createBookingGroupNotificationEmails",
      "agencyCurrencySign",
      "wordUsedForCandidates",
      "shiftJobStatusesWhereJobStatusVisible",
      "jobStatusesRefund",
      "onlyRefundForNonFilledJob",
      "includeBookingCancelReasonInCandidateEmail",
      "hideCandidatePreReleaseStatus",
      "clientTypesUseBookingCredits",
      "agencyUseBookingCredits",
      "doNotAutoPopulateAddress",
      "getCandidateBadge",
      "allowBookOnBlockedDate",
      "customMinutesIntervalBookingTime",
      "listPreviousMatchCandidatesOfEmployer",
      "language",
      "doNotBookOutsideOfficeHours",
      "warningBookOutsideOfficeHours",
    ]),
    employerShiftRequestEmailsByLocation() {
      let listLocations = this.getJobLocations(this.user, this.booking);
      return this.getListEmailSubmissionNotification(
        this.employerShiftRequestEmails,
        this.tryGet(
          () =>
            this.$store.getters.agency.advance_setting
              .employer_shift_request_emails_by_locations
        ),
        listLocations
      );
    },
    employerShiftChangeRequestEmailsByLocation() {
      if (!this.$store.getters.agency) {
        return [];
      }
      let listLocations = this.getJobLocations(this.user, this.booking);
      return this.getListEmailSubmissionNotification(
        this.$store.getters.agency.employer_shift_change_request_emails,
        this.tryGet(
          () =>
            this.$store.getters.agency.advance_setting
              .employer_shift_change_request_emails_by_locations
        ),
        listLocations
      );
    },
    // Cannot add or edit or delete bookings
    isViewOnly() {
      if (
        this.user &&
        this.user.types &&
        this.clientTypesViewOnlyBooking &&
        this.clientTypesViewOnlyBooking.length
      ) {
        if (
          this.hasCommonElement(
            this.user.types,
            this.clientTypesViewOnlyBooking
          )
        ) {
          return true;
        }
      }
      return false;
    },
    listTableFieldsBooking() {
      const result = [
        {
          displayLabel: "Date",
          model: "date",
          sort_model: "date",
          transformFunction: this.getTitle,
        },
        {
          displayLabel: "Candidate",
          model: "filler_name",
          transformFunction: this.getBookingFillerName,
        },
        {
          displayLabel: "Category",
          model: "category",
        },
        {
          displayLabel: "Start Time",
          model: "start_time",
        },
        {
          displayLabel: "End Time",
          model: "end_time",
        },
        {
          displayLabel: "Hours",
          model: "hours_worked",
        },
        {
          displayLabel: "Rate",
          model: "client_rate",
          transformFunction: (booking) => {
            if (!booking || !booking.client_rate) {
              return;
            }
            return `${this.currencySign(this.agencyCurrency)}${
              booking.client_rate
            }/hr`;
          },
        },
        {
          displayLabel: "Total",
          model: "total_client_charge",
          transformFunction: (booking) => {
            if (!booking || !booking.total_client_charge) {
              return;
            }
            return `${this.currencySign(this.agencyCurrency)}${
              booking.total_client_charge
            }`;
          },
        },
      ];
      if (
        this.hourlyServiceSelectionList &&
        this.hourlyServiceSelectionList.length
      ) {
        result.splice(4, 0, {
          displayLabel: "Service",
          model: "title",
        });
      }
      return result;
    },
    mapBookingGroup() {
      // map group_id => list of jobs
      const result = {};
      for (const job of this.bookingData) {
        if (job.job_group) {
          let list_jobs = [];
          if (result[job.job_group]) {
            list_jobs = result[job.job_group];
          }
          list_jobs.push(job);
          result[job.job_group] = list_jobs;
        }
      }
      return result;
    },
    defaultShiftJobStatus() {
      if (this.agency) {
        let listStatuses = this.agency.shift_job_statuses;
        if (listStatuses == null || listStatuses.length === 0) {
          return DEFAULT_SHIFT_JOB_STATUSES.map((item) => item.status);
        }
        return listStatuses.map((item) => item.status);
      } else {
        return [];
      }
    },
    // Use in PRICE_INFO_CALCULATION_MIXIN
    listPrices() {
      return this.priceList;
    },
    cancellationPolicy() {
      return (
        this.tryGet(
          () =>
            this.bookingField.additionalInformation.cancellation_policy.segments
        ) || []
      );
    },
    listBookingFields() {
      return this.getListShowFields(false);
    },
    listDisplayBookingFields() {
      return this.getListShowFields(true);
    },
    posterName() {
      if (!this.user) {
        return "";
      }
      if (this.user.first_name && this.user.last_name) {
        return `${this.user.first_name} ${this.user.last_name}`;
      } else if (this.user.name) {
        return this.user.name;
      }
    },
    listShowBooking() {
      let bookingData = this.bookingData;
      if (this.hidePastBooking) {
        if (this.bookingData == null) {
          return [];
        }
        bookingData = this.bookingData.filter(
          (booking) => !this.isPastBooking(booking)
        );
      }
      // Sort booking by date
      bookingData = bookingData.sort((booking1, booking2) => {
        if (booking1.start_time && booking2.start_time) {
          return new Date(booking1.date + "T" + booking1.start_time) >=
            new Date(booking2.date + "T" + booking2.start_time)
            ? 1
            : -1;
        } else {
          return new Date(booking1.date) >= new Date(booking2.date) ? 1 : -1;
        }
      });
      if (this.numberOfPastDays) {
        let filterStart = this.addDaysToDate(0 - Number(this.numberOfPastDays));
        bookingData = bookingData.filter((job) => {
          return job.date >= this.dateInDjangoFormat(filterStart);
        });
      }
      return bookingData;
    },
    listShowBookingCurrentPage() {
      return this.listShowBooking.slice(
        (this.currentPage - 1) * 100,
        this.currentPage * 100
      );
    },
    totalPage() {
      return Math.ceil(this.listShowBooking.length / 100);
    },
    listShowBookingTableView() {
      let filteredResult = this.listShowBooking;
      if (this.filterStart) {
        filteredResult = filteredResult.filter((job) => {
          return job.date >= this.dateInDjangoFormat(this.filterStart);
        });
      }

      if (this.filterEnd) {
        filteredResult = filteredResult.filter((job) => {
          return job.date <= this.dateInDjangoFormat(this.filterEnd);
        });
      }
      return filteredResult;
    },
    listZipCodes() {
      if (
        this.bookingField.additionalInformation &&
        this.bookingField.additionalInformation.list_zip_codes
      ) {
        return this.bookingField.additionalInformation.list_zip_codes
          .split(",")
          .map((item) => item.trim());
      }
      return [];
    },
    listShowCalendarJobs() {
      return this.calendarJobs;
    },
    listPriceServices() {
      // Not show in the application form (because user type is not defined)
      if (!this.user || !this.user.id) {
        return [];
      }
      let result = this.hourlyServiceSelectionList;
      // Filter by types
      result = result.filter(
        (price) =>
          !price.user_types ||
          !price.user_types.length ||
          this.containsAllElements(this.user.types, price.user_types)
      );
      // Filter by locations
      result = result.filter(
        (price) =>
          !price.locations ||
          !price.locations.length ||
          this.hasCommonElement(price.locations, this.user.locations)
      );

      result.forEach((price) => {
        let label = price.name;
        if (price.price2) {
          label = `${label}, $${price.price2} per hour`;
        }
        price.label = label;
      });
      return result;
    },
    disclaimerText() {
      if (
        !this.disclaimerTextBookingSection ||
        this.disclaimerTextBookingSection === "<br>"
      ) {
        return this.DEFAULT_DISCLAIMER_TEXT;
      }
      return this.disclaimerTextBookingSection;
    },
    editAccess() {
      if (
        this.user.id == this.$store.getters.userID ||
        this.$store.getters.isAgent === true
      ) {
        return true;
      } else {
        return false;
      }
    },
    maxNumberChildrenAllowed() {
      if (this.bookingField && this.bookingField.maxNumberChildrenAllowed) {
        return this.bookingField.maxNumberChildrenAllowed;
      }
      return 10;
    },
    listUpSertBookingFields() {
      this.listBookingFields.forEach((item) => {
        if (
          this.tryGet(() => item.model === "start_time") ||
          this.tryGet(() => item.model === "end_time")
        ) {
          if (!item.minutesInterval) {
            item.minutesInterval = this.customMinutesIntervalBookingTime;
          }
        }
        if (this.tryGet(() => item.model === "additional_dates")) {
          item.minutesInterval = this.customMinutesIntervalBookingTime;
        }
      });
      if (this.hasDateQuestion) {
        return [
          {
            type: FORM_TYPE.DATEPICKER,
            keyLangLabel: "BOOKING_DIALOG.LABEL.SELECT_DATE",
            model: "date",
            initialView: "day",
            minDate: this.isAgent ? null : new Date(),
          },
          ...this.listBookingFields,
        ];
      } else {
        return this.listBookingFields;
      }
    },
    listFieldsUpdateBooking() {
      return [
        {
          type: FORM_TYPE.DATEPICKER,
          keyLangLabel: "BOOKING_DIALOG.LABEL.SELECT_DATE",
          model: "date",
          initialView: "day",
          minDate: this.isAgent ? null : new Date(),
        },
        ...this.listBookingFields,
      ];
    },
    bookingCancellationReason() {
      return this.includeBookingCancelReasonInCandidateEmail &&
        this.booking.cancel_reason
        ? `Reason: ${this.booking.cancel_reason}`
        : "";
    },
    hasDurationField() {
      return (
        this.listFields &&
        this.listFields.some((field) => field.model === "duration")
      );
    },
  },
  methods: {
    ...mapActions([
      "createShiftJob",
      "updateShiftJob",
      "loadPriceList",
      "loadCandidateListMainInfo",
      "updateFillersOfJob",
      "setPublicCandidateList",
      "loadPreviousMatchCandidatesByEmployer",
      "reloadProfileBuilderList",
    ]),
    getBookingSummary(booking) {
      let title = this.getTitle(booking);
      if (booking.start_time && booking.end_time) {
        title +=
          " (" +
          this.convertTimeStringToStringAMPM(booking.start_time) +
          " - " +
          this.convertTimeStringToStringAMPM(booking.end_time) +
          ")";
      }
      return title;
    },
    showAddGroupDialog() {
      let optionList = [];
      const listNonPastBookings = this.bookingData.filter(
        (booking) => !this.isPastBooking(booking)
      );
      for (const booking of listNonPastBookings) {
        optionList.push({
          label: this.getBookingSummary(booking),
          id: booking.id,
        });
      }
      this.showInputDialog({
        title: "Add Booking Group",
        listFields: [
          {
            label: "Select Bookings",
            type: FORM_TYPE.MULTI_SELECT,
            isMulti: true,
            model: "ids",
            optionList: optionList,
            optionModel: "id",
            optionLabel: "label",
          },
        ],
        onSubmitCallback: this.createBookingGroup,
      });
    },
    async createBookingGroup(info) {
      await axios.post(`/create-job-group/`, {
        poster: this.user.id,
        agency: this.$store.getters.agencyID,
        agency_owner: this.$store.getters.agencyName,
        jobs: info.ids,
      });
      // Send email notification
      if (
        this.createBookingGroupNotificationEmails &&
        this.createBookingGroupNotificationEmails.length
      ) {
        let jobInfos = "";
        for (const id of info.ids) {
          const booking = this.bookingData.find((booking) => booking.id === id);
          jobInfos += `\n${this.getBookingSummary(booking)}`;
        }
        this.sendEmail(
          {
            ...this.$store.getters
              .bookingGroupCreatedAgencyNotificationEmailTemplate,
            recipients: this.createBookingGroupNotificationEmails,
          },
          jobInfos,
          this.user.first_name,
          this.user.last_name,
          this.user.email
        );
      }
      this.loadListBooking();
    },
    canEditBooking(status) {
      if (this.tryGet(() => this.JobStatusClientCantEditShiftBookings.length)) {
        return !this.JobStatusClientCantEditShiftBookings.includes(status);
      }
      return true;
    },
    // Fee client pay agency per booking
    getAgencyFee() {
      let amount = 0;
      if (!this.listShowBooking || !this.$refs.priceInfo) {
        return 0;
      }
      for (const priceInfoRef of this.$refs.priceInfo) {
        const perBookingAgencyFee = priceInfoRef.totalPerBookingAgencyFee;
        if (perBookingAgencyFee) {
          amount += Number(perBookingAgencyFee);
        }
        const agencyRate = priceInfoRef.agencyRate;
        if (agencyRate) {
          amount += priceInfoRef.bookingDuration * Number(agencyRate);
        }
        // Rush fee is fee pay to agency
        const rushFee = priceInfoRef.rushFee;
        if (rushFee) {
          amount += Number(rushFee);
        }
        // Admin fee
        const adminFee = priceInfoRef.adminFee;
        if (adminFee) {
          amount += Number(adminFee);
        }
        const adminFeeSubstraction = priceInfoRef.adminFeeSubstraction;
        if (adminFeeSubstraction) {
          amount += Number(adminFeeSubstraction);
        }
        const totalDiscount = priceInfoRef.totalDiscount;
        if (totalDiscount) {
          amount = amount - Number(totalDiscount);
        }
      }
      return amount;
    },
    // Fee client pay agency and candidate per booking
    getTotalFee() {
      let amount = 0;
      if (!this.listShowBooking || !this.$refs.priceInfo) {
        return 0;
      }
      for (const priceInfoRef of this.$refs.priceInfo) {
        const flatRate = priceInfoRef.totalFlatRate;
        if (flatRate) {
          amount += flatRate;
        }
      }
      return amount;
    },
    getListShowFields(isForView) {
      let listFields = Object.assign([], this.listFields);
      if (!this.isAgent && this.bookingField.listModelsAdminOnly) {
        listFields = listFields.filter(
          (field) =>
            !this.bookingField.listModelsAdminOnly.includes(field.model)
        );
      }
      if (isForView) {
        listFields = listFields.filter(
          (field) => field.type !== FORM_TYPE.HTML
        );
      }

      if (this.isAddBookingDialog && !this.excludeRepeatBooking) {
        // Find position to insert repeat fields
        let insertIndex = 0;
        for (let index = listFields.length - 1; index >= 0; index--) {
          // repeat fields are insert after the date, time fields
          if (
            ["date", "start_time", "end_time", "end_date"].includes(
              listFields[index].model
            )
          ) {
            insertIndex = index + 1;
            break;
          }
        }
        // Find recurring preset fields
        const recurringFieldIndex = listFields.findIndex(
          (field) => field.presetFields === "Recurring Fields"
        );
        if (recurringFieldIndex !== -1) {
          insertIndex = recurringFieldIndex;
        }
        listFields.splice(insertIndex, 0, {
          type: FORM_TYPE.CHECKBOX_ITEM,
          keyLangLabel: "BOOKING_DIALOG.LABEL.REPEAT",
          model: "repeat",
          isRequired: false,
        });
        listFields.splice(insertIndex + 1, 0, {
          type: FORM_TYPE.DATEPICKER,
          keyLangLabel: "BOOKING_DIALOG.LABEL.REPEAT_UNTIL",
          model: "repeat_end_date",
          showIf: "repeat",
          minDate: this.selectedDate,
          initialView: "day",
        });
        listFields.splice(insertIndex + 2, 0, {
          type: FORM_TYPE.LABEL,
          keyLangLabel: "BOOKING_DIALOG.LABEL.REPEAT_EVERY",
          showIf: "repeat",
        });
        listFields.splice(insertIndex + 3, 0, {
          type: FORM_TYPE.MULTI_SELECT,
          model: "repeat_count",
          optionList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
          showIf: "repeat",
          itemPerRow: 2,
          defaultValue: 0,
        });
        listFields.splice(insertIndex + 4, 0, {
          type: FORM_TYPE.MULTI_SELECT,
          model: "repeat_type",
          optionList: ["Days", "Weeks"],
          keyLangOptions: "BOOKING_DIALOG.OPTIONS.REPEAT_TYPE",
          showIf: "repeat",
          itemPerRow: 2,
          defaultValue: 1,
        });
        listFields.splice(insertIndex + 5, 0, {
          type: FORM_TYPE.CHECKBOX,
          model: "repeat_weekdays",
          keyLangLabel: "BOOKING_DIALOG.LABEL.REPEAT_ON",
          keyLangOptions: "BOOKING_DIALOG.OPTIONS.REPEAT_ON",
          optionList: [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
            "Sunday",
          ],
          showIf: "repeat_type",
          showIfValue: ["Weeks"],
          hasCheckAll: true,
          markAllAsChecked: this.selectAllDaysForRecurringRequests,
        });
      }

      if (this.hasNumberCandidateQuestion && this.isAddBookingDialog) {
        listFields.push({
          type: FORM_TYPE.MULTI_SELECT,
          keyLangLabel: "BOOKING_DIALOG.LABEL.NUMBER_CANDIDATE",
          keyLangLabelParams: [this.wordUsedForCandidates],
          optionList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
          model: "number_candidate",
          isRequired: false,
          defaultValue: 0,
        });
      }

      if (this.listPriceServices && this.listPriceServices.length) {
        // Find service selection preset fields
        const serviceSelectionFieldIndex = listFields.findIndex(
          (field) => field.presetFields === "Service Selection"
        );
        this.insertArrayInArray(
          listFields,
          [
            {
              type: FORM_TYPE.MULTI_SELECT,
              keyLangLabel: "BOOKING_DIALOG.LABEL.SELECT_SERVICE",
              optionListAll: this.listPriceServices,
              isMulti: false,
              optionModel: "name",
              optionLabel: "label",
              model: "title",
            },
          ],
          serviceSelectionFieldIndex
        );
      }
      if (
        this.quickbooksPriceSelectionList &&
        this.quickbooksPriceSelectionList.length
      ) {
        // Find quickbooks price selection preset field
        const quickbookPriceSelectionFieldIndex = listFields.findIndex(
          (field) => field.presetFields === "Quickbooks Price Selection"
        );
        if (quickbookPriceSelectionFieldIndex >= 0) {
          this.insertArrayInArray(
            listFields,
            [
              {
                type: FORM_TYPE.MULTI_SELECT,
                keyLangLabel: "BOOKING_DIALOG.LABEL.SELECT_QUICKBOOKS_PRICE",
                optionListAll: this.quickbooksPriceSelectionList,
                isMulti: false,
                optionModel: "id",
                optionLabel: "name",
                model: "qbd_pricing_id",
              },
            ],
            quickbookPriceSelectionFieldIndex
          );
        }
      }
      // Find candidate selection preset fields
      const candidateSelectionFieldIndex = listFields.findIndex(
        (field) => field.presetFields === "Candidate Selection"
      );
      if (candidateSelectionFieldIndex >= 0) {
        this.insertArrayInArray(
          listFields,
          [
            {
              ...listFields[candidateSelectionFieldIndex],
              type: FORM_TYPE.SLOT,
              label:
                listFields[candidateSelectionFieldIndex].label ||
                "Candidate Selection",
            },
          ],
          candidateSelectionFieldIndex
        );
      }
      if (!this.hideAdditionalDateQuestion && !this.hasDurationField) {
        // Find Add Additional Dates preset fields
        const addAdditionalDatesFieldIndex = listFields.findIndex(
          (field) => field.presetFields === "Add Additional Dates"
        );
        const additionalDateField = {
          type: FORM_TYPE.LIST_DATE_TIMES_PICKER,
          keyLangLabel: "BOOKING_DIALOG.LABEL.ADDITIONAL_DATES",
          model: "additional_dates",
          isRequired: false,
          allowPastDate: false,
        };
        if (addAdditionalDatesFieldIndex == -1) {
          listFields.splice(0, 0, additionalDateField);
        } else {
          this.insertArrayInArray(
            listFields,
            [additionalDateField],
            addAdditionalDatesFieldIndex
          );
        }
      }
      if (!this.excludeAddressQuestion) {
        const listAddressFields = [];
        listAddressFields.push({
          type: FORM_TYPE.TEXTBOX,
          keyLangLabel: "BOOKING_DIALOG.LABEL.BOOKING_ADDRESS",
          model: "address1",
        });
        listAddressFields.push({
          type: FORM_TYPE.TEXTBOX,
          keyLangLabel: "BOOKING_DIALOG.LABEL.ADDRESS_LINE2",
          hideDetailLabel: true,
          model: "address2",
          isRequired: false,
        });
        if (isForView) {
          listAddressFields.push({
            type: FORM_TYPE.TAG_HTML,
            hideDetailLabel: true,
            itemPerRow: 1,
            model: "[[city]], [[provincestate]], [[postal_code]]",
          });
        } else {
          listAddressFields.push({
            type: FORM_TYPE.TEXTBOX,
            keyLangLabel: "BOOKING_DIALOG.LABEL.CITY",
            hideDetailLabel: true,
            itemPerRow: 3,
            model: "city",
          });
          listAddressFields.push({
            type: FORM_TYPE.TEXTBOX,
            keyLangLabel: "BOOKING_DIALOG.LABEL.STATE",
            hideDetailLabel: true,
            itemPerRow: 3,
            model: "provincestate",
          });
          if (this.listZipCodes && this.listZipCodes.length) {
            listAddressFields.push({
              type: FORM_TYPE.MULTI_SELECT,
              keyLangLabel: "BOOKING_DIALOG.LABEL.ZIP_CODE",
              hideDetailLabel: true,
              optionList: this.listZipCodes,
              itemPerRow: 3,
              model: "postal_code",
            });
          } else {
            listAddressFields.push({
              type: FORM_TYPE.TEXTBOX,
              keyLangLabel: "BOOKING_DIALOG.LABEL.ZIP_CODE",
              hideDetailLabel: true,
              itemPerRow: 3,
              model: "postal_code",
            });
          }
        }
        // Find address preset fields
        const addressFieldIndex = listFields.findIndex(
          (field) => field.presetFields === "Address Fields"
        );
        const addressField = listFields.find(
          (field) => field.presetFields === "Address Fields"
        );
        if (addressField && addressField.selectUserAddresses) {
          const addressSelectionField = {
            type: FORM_TYPE.MULTI_SELECT,
            label: addressField.label,
            isMulti: false,
            model: "address_id",
            optionList: this.user.addresses,
            optionLabel: "address1",
            optionModel: "id",
          };
          this.insertArrayInArray(
            listFields,
            [addressSelectionField],
            addressFieldIndex
          );
        } else {
          this.insertArrayInArray(
            listFields,
            listAddressFields,
            addressFieldIndex
          );
        }
      }
      let hasChildrenQuestion = false;
      // Children selection question
      if (this.user && this.user.children && this.user.children.length) {
        const childrenSelectionFieldIndex = listFields.findIndex(
          (field) => field.presetFields === "Children Selection"
        );
        if (childrenSelectionFieldIndex >= 0) {
          hasChildrenQuestion = true;
          this.insertArrayInArray(
            listFields,
            [
              {
                ...listFields[childrenSelectionFieldIndex],
                type: FORM_TYPE.MULTI_SELECT,
                optionList: this.user.children,
                isMulti: true,
                model: "children_ids",
                optionLabel: "first_name",
                optionModel: "id",
              },
            ],
            childrenSelectionFieldIndex
          );
        }
      }

      if (!this.excludeChildrenQuestion) {
        const numberChildrenFieldIndex = listFields.findIndex(
          (field) => field.presetFields === "Number of Children"
        );
        this.insertArrayInArray(
          listFields,
          [
            {
              ...listFields[numberChildrenFieldIndex],
              isHidden: hasChildrenQuestion,
              type: FORM_TYPE.MULTI_SELECT,
              keyLangLabel: "BOOKING_DIALOG.LABEL.NUMBER_CHILDREN",
              optionList: [...Array(this.maxNumberChildrenAllowed).keys()].map(
                (i) => i + 1
              ),
              isMulti: false,
              model: "number_children",
            },
          ],
          numberChildrenFieldIndex
        );
      }

      if (this.user && this.user.pets && this.user.pets.length) {
        const petSelectionFieldIndex = listFields.findIndex(
          (field) => field.presetFields === "Pet Selection"
        );
        if (petSelectionFieldIndex >= 0) {
          this.insertArrayInArray(
            listFields,
            [
              {
                ...listFields[petSelectionFieldIndex],
                type: FORM_TYPE.MULTI_SELECT,
                optionList: this.user.pets,
                isMulti: true,
                model: "pet_ids",
                optionLabel: "name",
                optionModel: "id",
                isRequired: false,
              },
            ],
            petSelectionFieldIndex
          );
        }
      }

      if (
        this.listPreviousMatchCandidatesOfEmployer &&
        this.listPreviousMatchCandidatesOfEmployer.length
      ) {
        const previousMatchFieldIndex = listFields.findIndex(
          (field) =>
            field.presetFields === "Previously Matched Candidate Selection"
        );
        if (previousMatchFieldIndex >= 0) {
          this.insertArrayInArray(
            listFields,
            [
              {
                ...listFields[previousMatchFieldIndex],
                type: FORM_TYPE.MULTI_SELECT,
                optionList: this.listPreviousMatchCandidatesOfEmployer,
                isMulti: true,
                model: "selected_previous_match_ids",
                optionLabel: "filler_name",
                optionModel: "filler",
                isRequired: false,
              },
            ],
            previousMatchFieldIndex
          );
        }
      }

      if (
        this.normalizedCategoryList &&
        this.normalizedCategoryList.length > 1
      ) {
        // Find address preset fields
        const categoryFieldIndex = listFields.findIndex(
          (field) => field.presetFields === "Category"
        );
        this.insertArrayInArray(
          listFields,
          [
            {
              ...listFields[categoryFieldIndex],
              type: FORM_TYPE.MULTI_SELECT,
              keyLangLabel: "BOOKING_DIALOG.LABEL.SELECT_JOB_CATEGORY",
              optionList: this.categoryList,
              isMulti: false,
              model: "category",
            },
          ],
          categoryFieldIndex
        );
      }
      return listFields.filter(
        (field) => field.type !== FORM_TYPE.PRESET_FIELDS
      );
    },
    getNumberOfJob(day) {
      if (!this.calendarJobs) {
        return "";
      }
      const dateString = this.dateInDjangoFormat(day);
      const numberOfBooking = this.calendarJobs.filter(
        (item) => this.dateInDjangoFormat(item.startDate) == dateString
      ).length;
      if (numberOfBooking && numberOfBooking > 1) {
        return "(" + numberOfBooking + ")";
      }
      return "";
    },
    isPastBooking(booking) {
      let bookingDate = new Date(booking.date + "T23:59:59");
      // if (booking.end_time) {
      //   bookingDate = new Date(booking.date + "T" + booking.end_time);
      // }
      return bookingDate < new Date();
    },
    async getListBookings() {
      return new Promise(async (resolve, reject) => {
        const res = await axios.get(
          `/get-jobs-by-poster/?poster=${this.user.id}&job_type=${this.jobTypeShortTermQuery}&agency=${this.agencyID}&reports=true`
        );
        if (!res) {
          reject();
        }
        resolve(res.data.jobs);
      });
    },
    async handleUpdateObjects({
      actionType,
      data,
      assignees,
      numberOfBooking,
      hasResultDialog,
    }) {
      let targetJobs; // Creating jobs or updating jobs
      const oldBooking = { ...this.booking }; // Booking before update
      this.booking = data;
      let assignInfo = {};
      if (assignees && assignees.length) {
        const assignee = assignees[0];
        const isFilled =
          this.jobStatusAfterClientSelectCandidate === "Assigned";

        assignInfo = {
          status: this.jobStatusAfterClientSelectCandidate,
          filled: isFilled,
          filler: assignee.id,
          filler_name: `${assignee.first_name} ${assignee.last_name}`,
          filled_date: new Date(),
        };
      }
      if (actionType === ACTION_TYPE.ADD) {
        if (data.date) {
          this.selectedDate = new Date(data.date + "T00:00:00");
        }
        // Collapse all other booking (to expand the new one)
        this.bookingData.forEach((booking) => (booking.isExpand = false));
        const jobBookingInfo = {
          ...this.booking,
          start_time: this.getTimeString(this.booking.start_time),
          end_time: this.getTimeString(this.booking.end_time),
          date: this.dateInDjangoFormat(this.selectedDate),
          category: this.getJobCategory(
            this.booking,
            this.getCategoryList(this.bookingField)
          ),
          isExpand: true,
          id: this.tempID,
        };
        this.correctEndDate(jobBookingInfo);
        let title;
        if (this.booking.start_time && this.booking.end_time) {
          title = `${this.convertTimeAMPMToString(
            this.booking.start_time
          )} - ${this.convertTimeAMPMToString(this.booking.end_time)}`;
        } else {
          title = "Booking";
        }
        if (this.booking.title) {
          title += " " + this.booking.title;
        }
        const numberBooking = this.booking.number_candidate || 1;
        for (
          let bookingIndex = 0;
          bookingIndex < numberBooking;
          bookingIndex += 1
        ) {
          if (!this.api) {
            this.bookingData.push({ ...jobBookingInfo, ...assignInfo });
            this.calendarJobs.push({
              id: this.tempID,
              startDate: this.selectedDate,
              endDate: this.booking.end_date,
              startTime: this.getTimeString(this.booking.start_time),
              style: this.getBookingStyle(
                this.booking.status,
                this.selectedDate
              ),
              title: title,
            });
          }
          this.tempID += 1;
        }
        let listCreatedBookingIds = []; // List of created booking ids
        if (this.$refs.updateBookingDialog) {
          await this.$refs.updateBookingDialog.handleAfterSavingData(
            listCreatedBookingIds
          );
        }
      } else if (actionType === ACTION_TYPE.UPDATE) {
        targetJobs = [this.booking];
        const jobBookingInfo = {
          ...this.booking,
          start_time: this.getTimeString(this.booking.start_time),
          end_time: this.getTimeString(this.booking.end_time),
          category: this.getJobCategory(
            this.booking,
            this.getCategoryList(this.bookingField)
          ),
          ...assignInfo,
        };
        this.correctEndDate(jobBookingInfo);
        if (this.indexOfEdittingBooking >= 0) {
          this.bookingData[this.indexOfEdittingBooking] = jobBookingInfo;
          this.bookingData = [...this.bookingData];
          let bookingTitle;
          if (this.booking.start_time && this.booking.end_time) {
            bookingTitle = `${this.convertTimeAMPMToString(
              this.booking.start_time
            )} - ${this.convertTimeAMPMToString(this.booking.end_time)}`;
          } else {
            bookingTitle = "Booking";
          }

          if (this.booking.title) {
            bookingTitle += " " + this.booking.title;
          }
          this.calendarJobs[this.indexOfEdittingBooking].title = bookingTitle;

          this.calendarJobs[this.indexOfEdittingBooking].endDate =
            this.booking.end_date;
          this.calendarJobs[this.indexOfEdittingBooking].startTime =
            this.getTimeString(this.booking.start_time);
        }

        if (this.$refs.updateBookingDialog) {
          await this.$refs.updateBookingDialog.handleAfterSavingData();
        }
      } else if (actionType === ACTION_TYPE.DELETE) {
        if (this.indexOfEdittingBooking >= 0) {
          this.bookingData.splice(this.indexOfEdittingBooking, 1);
          this.calendarJobs.splice(this.indexOfEdittingBooking, 1);
        }
      }

      if (
        this.clientCanSelectMultipleCandidates &&
        assignees &&
        assignees.length
      ) {
        for (const targetJob of targetJobs) {
          await this.updateFillersOfJob({
            job: targetJob,
            fillers: assignees,
            status: this.jobStatusAfterClientSelectCandidate,
            notAllowStatus:
              this.jobStatusAfterClientSelectCandidate === "Assigned"
                ? null
                : "Assigned",
          });
        }
      }

      this.updateBookingIndex();
      this.$emit("input", this.bookingData);
    },
    updateBookingIndex() {
      // Update booking index
      if (this.bookingData) {
        let index = 0;
        for (const booking of this.bookingData) {
          if (booking.status == JOB_STATUSES.CANCELLED) {
            booking.index = -1;
          } else {
            booking.index = index;
            index += 1;
          }
        }
      }
    },
    getModifiedData(jobBookingInfo) {
      const result = [];
      for (const field of this.listFieldsUpdateBooking) {
        if (this.bookingField && this.bookingField.listModelsAdminOnly) {
          if (this.bookingField.listModelsAdminOnly.includes(field.model)) {
            continue;
          }
        }
        let oldValue = this.originalJob[field.model];
        let newValue = jobBookingInfo[field.model];
        if (!oldValue && !newValue) {
          continue;
        }
        if (oldValue === newValue) {
          continue;
        }
        if (["start_time", "end_time"].includes(field.model)) {
          oldValue = this.convertTimeStringToStringAMPM(oldValue);
          newValue = this.convertTimeStringToStringAMPM(newValue);
        } else if (field.model == "additional_dates") {
          newValue = newValue
            .map(
              (item) =>
                `${this.getDateString(
                  item.date
                )} (${this.convertTimeStringToStringAMPM(
                  item.start_time
                )} - ${this.convertTimeStringToStringAMPM(item.end_time)})`
            )
            .join(", ");
        }
        const fieldLabel =
          field.label || this.getLabelByKeys(field.keyLangLabel);
        result.push(
          `Old ${fieldLabel}: ${oldValue}, New ${fieldLabel}: ${newValue}`
        );
      }
      return result.join("\n");
    },
    setShowDate(d) {
      this.showDate = d;
    },
    getTimeStringAMPM(time) {
      return time.hh + ":" + time.mm + " " + time.A;
    },
    checkBookingOutSideBussinessHours() {
      if (!this.doNotBookOutsideOfficeHours) {
        return false;
      }
      const outsideResult = this.isJobCreatedInBusinessHour();
      if (!(outsideResult && outsideResult.isInside)) {
        this.showErrorDialog({
          innerHtml: this.replaceTagValue(this.warningBookOutsideOfficeHours, {
            office_hour_from: this.djangotimeformatAMPM(
              outsideResult.startTime
            ),
            office_hour_to: this.djangotimeformatAMPM(outsideResult.endTime),
          }),
        });
        return true;
      }
      return false;
    },
    async onClickDate(d) {
      if (this.isViewOnly) {
        console.log("1");
        return;
      }
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      if (!this.isAgent && d < today) {
        console.log("2");
        // Click a date in the past
        return;
      }
      console.log("3");
      // Check if booking in list blocked date
      if (
        !this.isAgent &&
        this.$store.getters.agencyPublic &&
        this.$store.getters.agencyPublic.shift_request_full_dates &&
        !this.allowBookOnBlockedDate
      ) {
        if (
          this.$store.getters.agencyPublic.shift_request_full_dates.includes(
            this.dateInDjangoFormat(d)
          )
        ) {
          this.showResultDialog("BOOKING_ON_BLOCKED_DATES_RESULT_DIALOG");
          return;
        }
      }
      if (!this.isAgent) {
        if (this.checkBookingOutSideBussinessHours()) {
          return;
        }
      }
      this.selectedDate = d;

      this.booking = {
        index: this.bookingData ? this.bookingData.length : 0,
      };
      if (!this.doNotAutoPopulateAddress) {
        this.booking = {
          ...this.booking,
          address1: this.user.address1,
          address2: this.user.address2,
          city: this.user.city,
          provincestate: this.user.provincestate,
          postal_code: this.user.postal_code,
          locations: this.user.locations,
        };
      }
      // Auto populate field
      this.autoPopulateFields();
      this.isAddBookingDialog = true;
      this.dialogTitle =
        this.getLabelByKeys("BUTTONS.ADD_A_BOOKING") + " - " + d.toDateString();
      this.hasDateQuestion = false;
      this.isShowBookingDialog = true;
    },
    autoPopulateFields() {
      for (const field of this.listBookingFields) {
        if (field.autoPopulateSource && field.model) {
          if (
            this.user[field.autoPopulateSource] &&
            !this.booking[field.model]
          ) {
            this.booking[field.model] = this.user[field.autoPopulateSource];
          }
        }
      }
    },
    async clickAddBooking() {
      if (!this.isAgent) {
        if (this.checkBookingOutSideBussinessHours()) {
          return;
        }
      }
      this.booking = {
        index: this.bookingData ? this.bookingData.length : 0,
      };
      if (!this.doNotAutoPopulateAddress) {
        this.booking = {
          ...this.booking,
          address1: this.user.address1,
          address2: this.user.address2,
          city: this.user.city,
          provincestate: this.user.provincestate,
          postal_code: this.user.postal_code,
        };
      }
      this.autoPopulateFields();
      this.dialogTitle = this.getLabelByKeys("BUTTONS.ADD_A_BOOKING");
      this.isAddBookingDialog = true;
      this.hasDateQuestion = true;
      this.selectedDate = null;
      this.isShowBookingDialog = true;
    },
    async handleClickDuplicateBooking(job) {
      this.booking = {
        ...job,
        index: this.bookingData ? this.bookingData.length : 0,
      };
      this.booking.status = "Requested";
      const listRemovedKeys = [
        "filled",
        "filler",
        "filled_date",
        "filler_name",
        "fillers",
      ];
      listRemovedKeys.forEach((key) => {
        delete this.booking[key];
      });
      this.dialogTitle = "Duplicate a booking";
      this.isAddBookingDialog = true;
      this.hasDateQuestion = true;
      this.selectedDate = null;
      this.isShowBookingDialog = true;
    },
    async onClickItem(event) {
      // id of booking which is clicked
      const bookingId = event.id;
      // Expand the booking which has bookingId, collapse all others
      this.bookingData.forEach(
        (booking) => (booking.isExpand = booking.id === bookingId)
      );
      this.bookingData = JSON.parse(JSON.stringify(this.bookingData));

      // Show assignee
      if (!this.api) {
        // Does not show dialog in Application Form
        return;
      }
    },
    handleClickCancelBooking(job, forceCloseBookingDialog = false) {
      if (forceCloseBookingDialog) {
        this.$nextTick(() => {
          this.$refs.jobInfoDialog.hideModal();
        });
        return;
      }
      this.booking = {
        ...job,
        start_time: this.getTimeFromString(job.start_time),
        end_time: this.getTimeFromString(job.end_time),
      };
      this.$refs.updateBookingDialog.data = { ...this.booking };
      this.$nextTick(() => {
        this.$refs.updateBookingDialog.showCancelBookingConfirmDialog();
      });
    },
    async handleClickEditBooking(job, index) {
      if (index == null) {
        index = this.listShowBooking.findIndex(
          (booking) => booking.id === job.id
        );
      }
      if (!index && this.listShowBooking) {
        // Find index of job in listShowBooking
        index = this.listShowBooking.findIndex(
          (booking) => booking.id === job.id
        );
      }
      this.selectedDate = job.date;
      this.originalJob = JSON.parse(JSON.stringify(job));
      this.booking = {
        ...job,
        start_time: this.getTimeFromString(job.start_time),
        end_time: this.getTimeFromString(job.end_time),
      };
      this.dialogTitle =
        "Edit Booking - " +
        new Date(this.selectedDate + "T00:00:00").toDateString();
      this.indexOfEdittingBooking = index;
      this.isAddBookingDialog = false;
      this.hasDateQuestion = true;
      this.isShowBookingDialog = true;
    },
    getTitle(job) {
      const startDate = new Date(job.date + "T00:00:00").toDateString();
      if (!job.end_date) {
        return startDate;
      }
      const endDate = new Date(job.end_date + "T00:00:00").toDateString();
      if (startDate === endDate) {
        return startDate;
      }
      return startDate + " - " + endDate;
    },
    getBookingStyle(status, date) {
      if (status === JOB_STATUSES.CANCELLED) {
        return "white-space: normal; border-color: #c7c5c3; background-color: #c7c5c3;";
      }
      if (this.isPastDate(date)) {
        return "white-space: normal; border-color: var(--bootstrapgrey); background-color: var(--bootstrapgrey);";
      }
      if (status === JOB_STATUSES.ASSIGNED) {
        return "white-space: normal; border-color: #e7e5ff; background-color: #e7e5ff;";
      }
      return "white-space: normal; border-color: #ff6969; background-color: #ff6969;";
    },
    isPastDate(date) {
      if (date) {
        let date1 = new Date(date);
        let userTimezoneOffset = new Date(date1).getTimezoneOffset() * 60000;
        let jobDate = new Date(date1.getTime() + userTimezoneOffset);
        let date2 = new Date();
        let userTimezoneOffset2 = new Date(date2).getTimezoneOffset() * 60000;
        let currentDate = new Date(date2.getTime() + userTimezoneOffset2);
        return (
          jobDate.toDateString() != currentDate.toDateString() &&
          Date.parse(new Date(date)) < Date.parse(new Date())
        );
      }
      return false;
    },
    // Save current expanding booking before reload list booking (to keep the expanding booking after reload)
    saveCurrentExpandingBooking() {
      if (this.bookingData == null) {
        this.expandingID = -1;
        return;
      }
      const expandingBooking = this.bookingData.find(
        (booking) => booking.isExpand
      );
      if (expandingBooking) {
        this.expandingID = expandingBooking.id;
        return;
      }
      this.expandingID = -1;
      return;
    },
    async loadListBooking(jobs) {
      const calendarJobs = [];
      const bookingData = [];
      let listBooking;
      if (jobs && !this.shiftJobProblemReports) {
        listBooking = jobs;
      } else {
        listBooking = await this.getListBookings();
      }
      listBooking = listBooking.sort((a, b) => (a.id > b.id ? 1 : -1));
      for (const booking of listBooking) {
        if (this.multipleBookingSections && booking.type) {
          //if job doesnt contain the sectionTitle then skip this job
          if (booking.type != this.sectionTitle) {
            if (
              !this.bookingField ||
              !this.bookingField.sectionBuilderId ||
              this.bookingField.sectionBuilderId !== booking.section_builder_id
            ) {
              continue;
            }
          }
        }
        if (!this.batchID) {
          this.batchID = booking.job_group;
        }
        const jobBookingInfo = {
          ...booking,
          client_rate:
            "client_rate" in booking
              ? booking.client_rate
              : this.calculatePricePerHour(booking),
          agency_fee:
            "agency_fee" in booking
              ? booking.agency_fee
              : this.calculateAgencyFee(booking),
          travel_fee:
            "travel_fee" in booking
              ? booking.travel_fee
              : this.calculateTravelFee(booking),
          rush_fee:
            "rush_fee" in booking
              ? booking.rush_fee
              : this.calculateRushFee(booking),
          candidate_rush_fee:
            "candidate_rush_fee" in booking
              ? booking.candidate_rush_fee
              : this.calculateCandidateRushFee(booking),
          per_booking_agency_fee:
            "per_booking_agency_fee" in booking
              ? booking.per_booking_agency_fee
              : this.getPerBookingAgencyFee(booking),
          per_booking_candidate_fee:
            "per_booking_candidate_fee" in booking
              ? booking.per_booking_candidate_fee
              : this.getPerBookingCandidateFee(booking),
          isExpand: booking.id === this.expandingID,
        };
        if (booking.total_candidate_pay) {
          jobBookingInfo["total_candidate_pay"] = booking.total_candidate_pay;
        }
        if (booking.candidate_rate) {
          jobBookingInfo["candidate_rate"] = booking.candidate_rate;
        }
        if (
          !jobBookingInfo["total_candidate_pay"] &&
          !jobBookingInfo["candidate_rate"]
        ) {
          const candidateFee = this.calculateCandidateFee(booking);
          if (candidateFee) {
            jobBookingInfo["total_candidate_pay"] = candidateFee;
          } else {
            jobBookingInfo["candidate_rate"] =
              this.calculateCandidateRate(booking);
          }
        }

        bookingData.push(jobBookingInfo);
        let title = "";
        let jobFiller = "";
        if (booking.filler_name && this.hideCandidateLastNameForShiftJobs) {
          jobFiller = booking.filler_name.split(" ")[0];
        }
        if (this.user.is_employer && this.showIdClientSideShiftJobCalendar) {
          title = `${booking.id} `;
        }
        if (booking.start_time && booking.end_time) {
          title += `${this.convertTimeStringToStringAMPM(
            booking.start_time
          )} - ${this.convertTimeStringToStringAMPM(booking.end_time)}`;
        } else if (booking.category) {
          title += booking.category;
        } else {
          title += "Booking";
        }
        if (booking.title) {
          title += " " + booking.title;
        }
        if (
          (this.showWeeklyScheduleReleaseButton &&
            booking.status === this.preReleaseShiftJobStatus) ||
          !booking.filler_name
        ) {
          if (this.$store.getters.isAgent) {
            title += ` (${booking.status})`;
          }
        } else {
          // Don't show status of Booking to Client
          if (jobFiller && this.hideCandidateLastNameForShiftJobs) {
            title += ` (${jobFiller})`;
          } else {
            title += ` (${booking.filler_name})`;
          }
        }
        // statuses where job status is visible to the client
        if (
          !this.isAgent &&
          this.shiftJobStatusesWhereJobStatusVisible.includes(booking.status)
        ) {
          title += ` (${booking.status})`;
        }

        calendarJobs.push({
          id: booking.id,
          startDate: booking.date,
          endDate: booking.end_date,
          startTime: booking.start_time,
          style: this.getBookingStyle(booking.status, booking.date),
          title: title,
        });
      }
      this.updateBookingIndex();
      this.bookingData = bookingData;
      this.calendarJobs = calendarJobs;
    },
    getBookingFillerName(booking) {
      let jobFiller = booking.filler_name || "";
      if (booking.filler_name && this.hideCandidateLastNameForShiftJobs) {
        jobFiller = booking.filler_name.split(" ")[0];
      }
      return jobFiller;
    },
    expandBooking(job) {
      this.bookingData.forEach((booking) => (booking.isExpand = false));
      job.isExpand = true;
      this.bookingData = JSON.parse(JSON.stringify(this.bookingData));
    },
    showDeleteGroupConfirm(group_id) {
      this.showConfirmDialog({
        key: "DELETE_BOOKING_GROUP_CONFIRM_DIALOG",
        onAcceptCallback: this.deleteGroup,
        onAcceptCallbackData: group_id,
      });
    },
    async deleteGroup(group_id) {
      await axios.delete(`/api/jobgroups/${group_id}`);
      this.loadListBooking();
    },
    async handleUnassignCandidate(filler) {
      // Reload selected job
      const res = await axios.get(`/api/jobs/${this.selectedJob.id}/`);
      this.selectedJob = res.data;
      this.listJobFiller = this.listJobFiller.filter(
        (jobFiller) => jobFiller.id !== filler.id
      );
      this.loadListBooking();
    },
    getFieldProperty(item, key) {
      if (item == null) {
        return "";
      }
      if (this.language) {
        if (item[key + "_lang_" + this.language]) {
          return item[key + "_lang_" + this.language];
        }
      }
      if (key === "label" && !item[key] && item.keyLangLabel) {
        if (item.keyLangLabelParams) {
          return this.getLabelByKeys(
            item.keyLangLabel,
            ...item.keyLangLabelParams
          );
        } else {
          return this.getLabelByKeys(item.keyLangLabel);
        }
      }
      return item[key];
    },
    handleShowBuilderSetting() {
      this.isShowSectionBuilderUpSertDialog = true;
    },
  },
};
</script>

<style scoped>
.description {
  font-size: 80%;
  font-weight: 400;
}

.booking-detail-container {
  max-height: 440px;
  overflow-y: auto;
}

.booking-detail {
  width: 100%;
}

.booking-container {
  display: flex;
}

.icon-containers {
  padding-top: 0.7em;
}

.hide-past-booking {
  padding-left: 20px;
}

.hide-past-booking > .form-check-label {
  margin-top: 0;
}

.hide-past-booking .past-booking-filter {
  margin-left: -20px;
}
.booking-calendar-container {
  flex-wrap: wrap-reverse;
}

.add-booking {
  margin-top: 0.5em;
}

.credit-info {
  margin-top: 0.4em;
}

.booking-group {
  display: flex;
}

.booking-group-info {
  flex-grow: 1;
}

.delete-group {
  flex-basis: 20px;
}

.booking-buttons-container {
  margin-top: 5px;
  font-weight: bold;
}

.booking-button {
  cursor: pointer;
}

.calendar-parent-container {
  background: white;
  background-clip: content-box, padding-box;
}

.price-info-container {
  line-height: 1;
}
.relative {
  position: relative;
}
.top-2 {
  top: 2px;
}

.calendar-btns > button {
  border: solid 1px var(--coredarkcolor);
}

.nav-button {
  cursor: pointer;
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/common/bookings/BookingSectionWithDialog.vue